export const paths = {
    home: 'home',
    storeList: 'storelist',
    mog: 'mog',
    ordering: 'ordering',
    profile: 'profile',
    app_inventory: 'app-inventory',
    settings: 'settings',
    orderconfirm: 'orderconfirm',
    newItemReport: 'reports/newitem',
    orderguideworksheet:'reports/orderguide-worksheet',
    access_denied: 'access_denied',
    error500: '500',
    no_stores: 'no-stores',
};
